import { render, staticRenderFns } from "./Terms.vue?vue&type=template&id=67d7f6da&scoped=true"
var script = {}
import style0 from "./Terms.vue?vue&type=style&index=0&id=67d7f6da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d7f6da",
  null
  
)

export default component.exports